<template>
  <v-carousel hide-delimiters interval="10000">
    <v-carousel-item
      v-for="(item,i) in items"
      :key="i"
      :src="item.src"
    ></v-carousel-item>
  </v-carousel>
</template>
<script>
export default {
  computed: {
    options () {
      var isOn = true
      return {
        cycle: isOn ? 10000 : 0
      }
    }
  },
  methods: {},
  data () {
    return {
      items: [
        {
          src: 'banner2.jpg'
        },
        // {
        //   src: 'banner3.jpg'
        // },
        {
          src: 'banner4.jpg'
        },
        {
          src: 'banner5.jpg'
        },
        {
          src: 'banner6.jpg'
        }
      ]
    }
  }
}
</script>

<style>
/* #landingBanner {
  display:block;
  position: absolute;
  top: 0;
} */
</style>
